import script from "./OidcAuth.vue?vue&type=script&lang=js"
export * from "./OidcAuth.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__